module.exports = __webpack_public_path__ + "img/qingtv_logo.0305c247.png";